import { Controller } from '@hotwired/stimulus';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

function isSameOriginRedirectUrl(url) {
  if (typeof url !== 'string' || url.length === 0) return false;

  if (url.startsWith('/') && !url.startsWith('//')) return true;

  try {
    return new URL(url, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
}

export default class extends Controller {
  static targets = ['toolsBody', 'toolsChevron', 'extraTool', 'moreToolsButton'];

  toggleTools(event) {
    const hidden = this.toolsBodyTarget.classList.toggle('hidden');
    this.toolsChevronTarget.classList.toggle('rotate-180');
    event.currentTarget.setAttribute('aria-expanded', String(!hidden));
  }

  toggleAllTools() {
    const expanded = this.extraToolTargets.some((el) => !el.classList.contains('hidden'));
    this.extraToolTargets.forEach((el) => el.classList.toggle('hidden', expanded));
    this.moreToolsButtonTarget.textContent = expanded
      ? this.moreToolsButtonTarget.dataset.showLabel
      : this.moreToolsButtonTarget.dataset.hideLabel;
  }

  async confirmDelete(event) {
    event.preventDefault();

    const link = event.currentTarget;
    const message = link.dataset.confirmMessage;

    const result = await Swal.fire({
      text: message,
      title: 'Jesteś pewien?',
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Usuń',
      confirmButtonColor: '#DC2626',
      cancelButtonText: 'Anuluj',
      cancelButtonColor: '#1E88E5',
    });

    if (!result.isConfirmed) return;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    const response = await fetch(link.href, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': csrfToken,
        Accept: 'text/html',
      },
      credentials: 'same-origin',
    });

    if (response.redirected && isSameOriginRedirectUrl(response.url)) {
      window.location.href = response.url;
      return;
    }

    window.location.reload();
  }
}
